export default "__VITE_ASSET__DG0e6_hE__"